import Home3 from './home-3.vue'
export default Home3